module.exports = __webpack_public_path__ + "static/img/celoscope-detail-18.83d3d7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-detail-18.jpg
// module id = 29oS
// module chunks = 51